import CONST from '../../../../../includes/primitives/_constant_trion'

export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
    chartData:      [],
    
    canvasForms:  null,
    canvasGroup:  null,
    canvasChart:  null,

    timeline:     {},


  }),
  
  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}